import InlineAlert from './InlineAlert';

export default InlineAlert;
